import { styled } from 'styled-components';
import { COLORS } from '@ydistri/theme';

export const ConfigurationTable = styled.table`
  width: 100%;
  min-width: 48rem;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
`;

export const ConfigurationColumn = styled.col`
  width: 28%;
`;

export const TierColumn = styled.col`
  width: 18%;
`;

export const HeaderCell = styled.th<{ $isDefault?: boolean }>`
  height: 2rem;
  padding: 0.25rem;
  background-color: ${p => (p.$isDefault ? COLORS.TABLE_HIGHLIGHT_ORANGE : 'transparent')};
  font-weight: 600;
  text-align: left;
  vertical-align: middle;
`;

export const RowHeaderCell = styled.th`
  height: 2rem;
  padding: 0.25rem;
  font-weight: normal;
  text-align: left;
  vertical-align: middle;
`;

export const DataCell = styled.td<{ $isDefault?: boolean }>`
  height: 2rem;
  padding: 0.25rem;
  background-color: ${p => (p.$isDefault ? COLORS.TABLE_HIGHLIGHT_ORANGE : 'transparent')};
  vertical-align: middle;
`;
